import PropTypes from 'prop-types';
import Link from '../Link/Link';
import AnchorLink from '../AnchorLink/AnchorLink';

const InvestorMenuLink = {};

InvestorMenuLink.propTypes = Object.assign({}, Link.propTypes, {
    isActive: PropTypes.bool,
    secondaryMenu: PropTypes.shape({
        links: PropTypes.arrayOf(PropTypes.shape(AnchorLink.propTypes)),
    }),
});

export default InvestorMenuLink;


// WEBPACK FOOTER //
// ./src/components/Models/InvestorMenuLink/InvestorMenuLink.jsx